import Vue from 'vue'
import App from './App'
import firebase from 'firebase/app'
import colors from 'vuetify/es5/util/colors'
import router from './router'
import { store } from './store'
import DateFilter from './filters/date'
import DateWithoutTimeFilter from './filters/dateWithoutTime'
import FormattedDate from './filters/formatteddate'
import TemperatureFilter from './filters/temperature'
import LowerCase from './filters/lowercase'
import UpperCase from './filters/uppercase'
import toFixedOne from './filters/tofixedone'
import toFixedZero from './filters/tofixedzero'
import toKiloGrama from './filters/tokilograma'
import doNotShowNaNValue from './filters/donotshownanvalue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueI18n from 'vue-i18n'
import messages from './i18n'
import { initAlarmSound } from './utils/alarm-sound'
import { registerWebPush, unregisterWebPush } from './utils/web-push'

Vue.use(VueI18n)

const SUPPORTED_LANGUAGES = ['pt_BR', 'en_US', 'es_ES']
const DEFAULT_LANGUAGE = 'pt_BR'

function getStoredLanguage () {
  try {
    const stored = window.localStorage.getItem('language')
    return SUPPORTED_LANGUAGES.indexOf(stored) !== -1 ? stored : DEFAULT_LANGUAGE
  } catch (err) {
    return DEFAULT_LANGUAGE
  }
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: getStoredLanguage(), // restore the user's preferred language
  messages // set locale messages
})

Vue.use(Vuetify, {
  theme: {
    primary: colors.blue.darken2,
    primaryWithoutLigth: '#113DBF',
    primary10: '#040f2f',
    primary20: '#081E5E',
    primary30: '#0D2D8C',
    primary60: '#446FEE',
    primary70: '#5E7CD4',
    primary90: '#D0DBFB',
    gray10: '#1A1A1A',
    gray40: '#5C6070',
    gray50: '#73788C',
    gray70: '#ABAEBA',
    primary95: '#E8EDFD',
    secondaryWithoutLight: '#84BD13',
    secondary30: '#618b0e',
    background: '#FCFCFD',
    errorWithoutLigth: '#b3261e',
    tertiary: '#00aeef',
    accent: colors.blue.accent2,
    secondary: colors.grey.lighten1,
    info: colors.blue.lighten1,
    warning: colors.amber.darken2,
    error: colors.red.accent4,
    success: colors.green.lighten2
  }
})

Vue.config.productionTip = false

Vue.filter('date', DateFilter)
Vue.filter('dateWithoutTime', DateWithoutTimeFilter)
Vue.filter('formatted-date', FormattedDate)
Vue.filter('temperature-filter', TemperatureFilter)
Vue.filter('lower-case-filter', LowerCase)
Vue.filter('upper-case-filter', UpperCase)
Vue.filter('toFixedOne', toFixedOne)
Vue.filter('toFixedZero', toFixedZero)
Vue.filter('toKiloGrama', toKiloGrama)
Vue.filter('doNotShowNaNValue', doNotShowNaNValue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
  created () {
    initAlarmSound()
    firebase.initializeApp({
      apiKey: 'AIzaSyD9-RHIjF4vkejef3OhkPUHqBLpFFo_d5E',
      authDomain: 'inobram-platform.firebaseapp.com',
      // Opt-in for local end-to-end runs: FIREBASE_DATABASE_URL points the app at
      // the Realtime Database emulator (see api-platform-v2/firebase-emulator).
      // Unset in every deployed build, so the real database is used.
      databaseURL: process.env.FIREBASE_DATABASE_URL || 'https://inobram-platform.firebaseio.com',
      projectId: 'inobram-platform',
      storageBucket: 'inobram-platform.appspot.com',
      messagingSenderId: '882668789300',
      appId: '1:882668789300:web:0817aa0b9370e5ca96b461',
      measurementId: 'G-YSZQ1ZCHDP'
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignUserIn', user)
        registerWebPush()
        // Own the active-alarms realtime subscription at session lifetime so it
        // survives all in-app navigation and is torn down only on sign-out.
        this.$store.dispatch('subscribeActiveAlarms')
        this.$store.dispatch('fetchNotificationHistory')
      } else {
        unregisterWebPush()
        this.$store.dispatch('unsubscribeActiveAlarms')
        this.$store.commit('clearNotificationHistory')
      }
      // Signal that the initial auth state has been resolved (fires with user
      // or null). Router guards wait on this so a hard refresh on a protected
      // deep link doesn't redirect an authenticated user to /signin.
      this.$store.commit('setAuthReady', true)
    })
    firebase.database().ref('.info/connected').on('value', (snap) => {
      if (snap.val() === true) {
        this.$store.dispatch('setConnection', true)
      } else {
        this.$store.dispatch('setConnection', false)
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js